"use client"
import React, { createContext, useContext, useState } from 'react';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isZoomIn, setIsZoomIn] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isVisibleLogo, setIsVisibleLogo] = useState(false);
  const [isCompleted, setIsCompleted] = useState(true);
  const show = () => {
    setProgress(0);
    setIsVisible(true);
    setIsVisibleLogo(true );
    setIsCompleted(false);
    document.body.style.overflow = "hidden";
  }

  const hide = () => {
    setIsVisible(false);
    setIsZoomIn(false);
  }
  const updateProgress = (value) => {setProgress(value);
  };
  const zoomIn = () => setIsZoomIn(true);
  return (
    <LoadingContext.Provider value={{ isVisible, progress, show, hide, updateProgress, zoomIn, isZoomIn,setIsVisibleLogo,isVisibleLogo,setIsCompleted,isCompleted }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);